// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2a5f22af","644":"ffcae826"}[chunkId] + ".chunk.js";
};